import { render } from "./NotebookView.vue?vue&type=template&id=78264bda&scoped=true&ts=true"
import script from "./NotebookView.vue?vue&type=script&lang=ts"
export * from "./NotebookView.vue?vue&type=script&lang=ts"

import "./NotebookView.vue?vue&type=style&index=0&id=78264bda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78264bda"]])

export default __exports__